// extracted by mini-css-extract-plugin
export default {"qpayContain":"style_qpayContain__MJOK6","errorText":"style_errorText__eD1we"};